import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

export default function ExpiryDropdown({ expiry, onSelect, expiries }) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <td className="mr-[16px]">
      <div className="relative" ref={ref}>
        <div
          onClick={() => setIsOpen(!isOpen)}
          className="px-2 py-[6px] text-[10px] font-semibold border border-n300 rounded bg-p400 text-p300 cursor-pointer flex justify-between items-center gap-1 min-w-24">
          <span>{expiry || "Select Expiry"}</span>
          <ChevronDown size={12} className="text-p300" />
        </div>

        {isOpen && (
          <ul className="absolute z-10 w-full bg-p400 text-p300 border border-n300 rounded shadow-md h-[100px] overflow-auto text-[10px] no-scrollbar">
            {expiries.map((date, idx) => (
              <li
                key={idx}
                className="py-1 px-2 hover:bg-n200 cursor-pointer"
                onClick={() => {
                  onSelect(date);
                  setIsOpen(false);
                }}>
                {date}
              </li>
            ))}
          </ul>
        )}
      </div>
    </td>
  );
}
